import { Injectable } from "@angular/core";
import { AccountType, UserRole } from "@eemo/api-client";

export interface UserInfoToNative {
  displayName: string;
  email: string;
  uid: string;
  role: UserRole;
  accountType: AccountType;
}

export interface Credentials {
  username: string;
  password: string;
}

export interface MenuToNative {
  id: MenuToNativeId;
  title: string;
  icon: string;
  link: string;
  chip?: string; // number
  chipText?: string;
  childs?: MenuToNative[];
  show: boolean;
  collapse: boolean;
  showIconCollapse: boolean;
  disabled?: boolean;
  removed?: boolean;
  subTitle?: string;
  kpi?: number;
}

export enum MenuToNativeId {
  HOME_PROPERTY = "HOME_PROPERTY",
  PROP_MAIN = "PROP_MAIN",
  PROP_INFO = "PROP_INFO",
  FICHE_SECOURS = "FICHE_SECOURS",
  BOOKLET = "BOOKLET",
  LOCATION = "LOCATION",
  BUILDING = "BUILDING",
  ENERGY = "ENERGY",
  EQUIPMENT = "EQUIPMENT",
  FINANCIAL = "FINANCIAL",
  PEOPLE = "PEOPLE",
  CONDOMINIUM = "CONDOMINIUM",
  PHOTO = "PHOTO",
  TRACKING = "TRACKING",
  TIMELINE = "TIMELINE",
  CONSUMPTION = "CONSUMPTION",
  MAINTENANCE = "MAINTENANCE",
  WORK = "WORK",
  TRACKING_FINANCIAL = "TRACKING_FINANCIAL",
  VAULT = "VAULT",
  PROP_SALE = "PROP_SALE",
  PROP_SHARES = "PROP_SHARES",
  PROP_SERVICES = "PROP_SERVICES",
  SHARES = "SHARES",
  LOGOUT = "LOGOUT",
  DROPBOX = "DROPBOX",
  CONNECTORS = "CONNECTORS",
  KPIS = "KPIS",
  ADMIN = "ADMIN",
  PROFILE = "PROFILE",
  MAIN_CONDO = "MAIN_CONDO",
  CONTACTS = "CONTACTS",
  HELP = "HELP",
  NOTIFICATIONS = "NOTIFICATIONS",
}

interface BridgeNativeWebviewInterface {
  launchScan(): void;
  newMenu(menu: MenuToNative[] | string): MenuToNative;
  notificationsCount(count: number): number;
  userInfo(user: UserInfoToNative | null | string): UserInfoToNative;
  userAvatar(avatar: string): string;
  isAuthenticated(isAuthenticated: boolean): boolean;
  saveCredentials(credentials: string): Credentials;
  askCredentials(isAsking: boolean): Credentials;
  askSubscribeToNotifications(isAsking: boolean): Credentials;
}
declare let instance: BridgeNativeWebviewInterface;

@Injectable({
  providedIn: "root",
})
export class BridgeService {
  static launchScan() {
    try {
      instance.launchScan();
    } catch (error) {
      // console.log('laucnhscan: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.launchScan.postMessage(true);
    } catch (error) {
      // console.log('laucnhscan: pas depuis une app native ios', error);
    }
  }

  static newMenu(menu: MenuToNative[]) {
    try {
      instance.newMenu(JSON.stringify(menu));
    } catch (error) {
      // console.log('newMenu: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.newMenu.postMessage(menu);
    } catch (error) {
      // console.log('newMenu: pas depuis une app native ios', error);
    }
  }

  static notificationsCount(count: number) {
    try {
      instance.notificationsCount(count);
    } catch (error) {
      // console.log('notificationsCount: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.notificationsCount.postMessage(
        count
      );
    } catch (error) {
      // console.log('notificationsCount: pas depuis une app native ios', error);
    }
  }

  static userInfo(user: UserInfoToNative | null) {
    try {
      instance.userInfo(JSON.stringify(user));
    } catch (error) {
      // console.log('userInfo: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.userInfo.postMessage(user);
    } catch (error) {
      // console.log('userInfo: pas depuis une app native ios', error);
    }
  }

  static userAvatar(avatar: string) {
    try {
      instance.userAvatar(avatar);
    } catch (error) {
      // console.log('userAvatar: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.userAvatar.postMessage(avatar);
    } catch (error) {
      // console.log('userAvatar: pas depuis une app native ios', error);
    }
  }

  static isAuthenticated(isAuthenticated: boolean) {
    try {
      instance.isAuthenticated(isAuthenticated);
    } catch (error) {
      // console.log('isAuthenticated: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.isAuthenticated.postMessage(
        isAuthenticated
      );
    } catch (error) {
      // console.log('isAuthenticated: pas depuis une app native ios', error);
    }
  }

  static saveCredentials(credentials: Credentials) {
    try {
      instance.saveCredentials(JSON.stringify(credentials));
    } catch (error) {
      // console.log('isAuthenticated: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.saveCredentials.postMessage(
        credentials
      );
    } catch (error) {
      // console.log('saveCredentials: pas depuis une app native ios', error);
    }
  }

  static askCredentials(isAsking: boolean) {
    try {
      instance.askCredentials(isAsking);
    } catch (error) {
      // console.log('isAsking: pas depuis une app native android', error);
    }

    try {
      (window as any).webkit.messageHandlers.askCredentials.postMessage(
        isAsking
      );
    } catch (error) {
      // console.log('isAsking: pas depuis une app native ios', error);
    }
  }

  static askSubscribeToNotifications(isAsking: boolean) {
    try {
      instance.askSubscribeToNotifications(isAsking);
    } catch (error) {
      // console.log('isAsking: pas depuis une app native android', error);
    }

    try {
      (
        window as any
      ).webkit.messageHandlers.askSubscribeToNotifications.postMessage(
        isAsking
      );
    } catch (error) {
      // console.log('isAsking: pas depuis une app native ios', error);
    }
  }
}
